( function($) {
	function load_more_resources_func( e, el, item ) {
		e.preventDefault();

		// disable load more button for accidental double clicks
		el.prop( 'disabled', true );

		// Pass in any necessary attributes
		var button       = el,
				max_page     = el.attr( 'max-pages' ),
				current_page = el.attr( 'current-page' );
		var	data = {
			action: el.attr( "action" ),
			'post_type': 'post',
			'category': el.attr( "category" ),
			'page': current_page,
			'device': el.attr( "device" ),
			site: "", // value required for multisites
		};

		// Get the button text so it can reset
		var buttonText = el.text();

		$.ajax( {
			url: data.site + "/wp-admin/admin-ajax.php", // AJAX handler
			data: data,
			type: "POST",

			beforeSend: function () {
				if( document.documentElement.lang.includes( 'fr' ) ) {
					button.text( 'Chargement...' ); // change the button text
				}

				else {
					button.text( 'Loading...' ); // change the button text
				}
			},

			success: function( html ) {
				// re-enable the load more button
				el.prop( 'disabled', false );

				if( html ) {
					item.before( html );			

					button.attr( 'current-page', ++current_page );
					button.text( '' );

					if( el.attr( "device" ) === 'desktop' ) {
						button.append( buttonText + ' <i class="fa-solid fa-chevron-down"></i>' );
					}

					if( el.attr( "device" ) === 'mobile' ) {
						button.append( buttonText + ' <i class="fa-solid fa-arrow-right"></i>' );
					}

					// if last page
					// To use === , both values need to be the same type
					if( current_page == max_page ) {
						button.hide();
					}
				}
				
				else {
					console.log( 'something went wrong' );
				}
			},
		} );
	}

	$( '.load-more-resources-btn' ).on( 'click', function(e) {		
		load_more_resources_func( e, $( this ), $( this ).parent( '.load-more-card' ) );
	} );

	$( '.load-more-resources-desktop-btn' ).on( 'click', function(e) {		
		load_more_resources_func( e, $( this ), $( this ) );
	} );
} )( jQuery );
